import { axios, Response } from '../index'

const updateGroupUsersName = (
  groupId: number,
  title: string
): Response<null> => {
  return axios.put(`/v1/profiles/${groupId}`, { title })
}

export default updateGroupUsersName
